import Cliente from "@/domain/clientes/Clientes.js";
import Table from "./Table";
export default class TableClientes extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers = [
            { text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false },
            { text: "Razão Social", value: "xNome", show: true, width: "500px", pesq: true, enable: true },
            { text: "CNPJ", value: "CNPJ", width: "500px", show: true, pesq: true, enable: true },
            { text: "Tipo", value: "trabFiliado", width: "500px", show: true, pesq: true, enable: true },
            { text: "Primeira venda", value: "dtPrimeiraCompra", width: "500px", show: true, pesq: false, enable: true },
            { text: "Última venda", value: "dtUltimaCompra", width: "500px", show: true, pesq: false, enable: true },
            { text: "Menor valor de venda", value: "vlrMin", width: "500px", show: true, pesq: false, enable: true },
            { text: "Maior valor de venda", value: "vlrMax", width: "500px", show: true, pesq: false, enable: true },
            { text: "Vendas", value: "qtd", width: "500px", show: true, pesq: false, enable: true },
            { text: "Serviço prestado", value: "qntServico", width: "500px", show: true, pesq: false, enable: true },
            { text: "Data da inclusão", value: "dtInclusao", width: "500px", show: false, pesq: false, enable: true },
            { text: "IE", value: "IE", width: "500px", show: false, pesq: false, enable: true },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
            // { text: "customValues", value: "customValues", show: false, pesq: false, enable: false},
            { text: "enderEmit", value: "enderEmit", show: false, pesq: false, enable: false },
            { text: "conta", value: "conta", show: false, pesq: false, enable: false },
            { text: "nfes", value: "nfes", show: false, pesq: false, enable: false },
        ]
        return headers
    }

    setNota(arrayNotas, notas) {

        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {

            try {
                if (!notas[i].primeiraCompra) {
                    throw new Error(`Data inválida para construção`)
                }
                newArray.push(
                    new Cliente(
                        notas[i].client._id,
                        notas[i].client.dtInclusao,
                        notas[i].client.CNPJ,
                        notas[i].client.CPF,
                        notas[i].client.xNome,
                        notas[i].client.IE,
                        notas[i].qtd,
                        notas[i].vlrMin,
                        notas[i].vlrMax,
                        notas[i].primeiraCompra,
                        notas[i].ultimaCompra,
                        notas[i].servicoPrestado,
                        notas[i].client.customValues,
                        notas[i].client.enderDest,
                        notas[i].client.nfes,
                        notas[i].client.cliente,
                    )

                );



            } catch (err) {
                console.log(`Erro ao instanciar cliente: ${notas[i].client.xNome} \n\n${err}`)
            }
        }
        this.pagination.sortBy = 'xNome';
        this.pagination.descending = false;
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }

    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableClientes.js